// extracted by mini-css-extract-plugin
export default {"sokeresultat":"dhsgMYmk4-sokeresultat","beskrivelse":"dhsgR5hM0-beskrivelse","antall":"dhsgSntwj-antall","henter":"dhsgNR5Zd-henter"};